// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuButton_root__2p-DT","openMenu":"MenuButton_openMenu__2T0Q7 MenuButton_root__2p-DT","closeMenu":"MenuButton_closeMenu__1zqK3 MenuButton_root__2p-DT"};